
import log from "plugins/loglevel/index"
import WaitObjectByPathPromise from "app/wait_object_by_path_promise"
import DataRetriever from "app/data_retriever"


const LOGGING_PREFIX = "App.Tracking.Google.Event"
const GOOGLE_ANALYTICS_TRACKER_NAME = (() => {
  const name: unknown = DataRetriever.get("google-analytics-tracker-name")
  if (typeof name !== "string" || name.length === 0) {
    return null
  }
  return name
})()

interface EventParams {
  category: string,
  action: string,
  options?: {
    eventLabel?: string,
    eventValue?: number,
    nonInteraction?: boolean,
    [key: string]: unknown,
  },
}

/*
 * @see https://developers.google.com/analytics/devguides/collection/analyticsjs/events
 *
 */
const track = ({category, action, options= {}}: EventParams): void => {
  if (typeof category === "undefined") {
    log.debug("category missing!")
    return
  }

  if (typeof action === "undefined") {
    log.debug("action missing")
    return
  }

  const debug_message_fragments = [
    LOGGING_PREFIX,
    "about to track event with:",
    [
      `category: [${category}]`,
      `action: [${action}]`,
      `options: [${JSON.stringify(options)}]`,
    ].join(" ,"),
  ]

  log.debug(debug_message_fragments.join(" "))

  // UA event implementation
  WaitObjectByPathPromise("ga")
  .then((ga) => {
    const final_options = Object.assign({}, {
      hitType:        "event",  // Required.
      eventCategory:  category, // Required.
      eventAction:    action,   // Required.
    }, options)

    const dest = GOOGLE_ANALYTICS_TRACKER_NAME === null ? "send" : `${GOOGLE_ANALYTICS_TRACKER_NAME}.send`

    ga(dest, final_options)

    log.debug(`${LOGGING_PREFIX} PageView tracked`)
  })
  .catch(() => {
    log.warn("ga is undefined!")
  })
}

export default { track }
export { track }
